module.exports = __webpack_public_path__ + "img/employer_registration.37dd06e2.png";